import { TrackingEvent } from '../../../Entities/Schema.entity';

import { createAlertEmailConfirmationSchema } from './CreateAlertEmailConfirmationSchema';

export type CreateAlertEmailConfirmationEvent = TrackingEvent<Record<any, any>>;

export const createAlertEmailConfirmationToEvent = (): CreateAlertEmailConfirmationEvent => {
  const event: CreateAlertEmailConfirmationEvent = {
    schema: createAlertEmailConfirmationSchema.ref,
    data: {},
  };

  return event;
};
